/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Owner_LastInputs */

const cs_auth_signup_owner_last = /** @type {(inputs: Auth_Signup_Owner_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příjmení majitele`)
};

const en_auth_signup_owner_last = /** @type {(inputs: Auth_Signup_Owner_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner last name`)
};

/**
* | output |
* | --- |
* | "Owner last name" |
*
* @param {Auth_Signup_Owner_LastInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_owner_last = /** @type {((inputs?: Auth_Signup_Owner_LastInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Owner_LastInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_owner_last(inputs)
	return cs_auth_signup_owner_last(inputs)
});